import { Navigate, useLocation } from 'react-router-dom';
import { JSX } from 'react/jsx-runtime';
import { useAuth } from '../providers/auth-provider';

export default function ProtectedRoute({ children }: { children: JSX.Element }) {
  const auth = useAuth();
  const location = useLocation();
  const isLoading: boolean = auth.getIsLoading();
  const isAuthenticated: boolean = auth.getIsAuthenticated();

  if (isLoading) {
    return <div>Loading...</div>; // or a spinner
  }

  return isAuthenticated ? children : <Navigate to="/403" replace state={{ returnTo: location.pathname + location.search + location.hash }} />;
}
